import React from 'react';
import { Col, Container, Row, Button, Table } from 'react-bootstrap';

import './styles/invitereferral.css';

export default function inviteReferral() {
  return (
    <>
      <div className="invitereferral">
        <Container>
            <Row>
            <div className="invite_reff_head d-flex justify-content-start mb-4">
                    <h2>Referral</h2>
                </div>
                <Col>
                  <div className="invite_reff_col">
                    <div className="invite_reff_btns d-flex gap-4">
                        <div className="invite_reff_btn">
                            <Button className='active'>Spot</Button>
                        </div>
                        <div className="invite_reff_btn">
                            <Button>Futures</Button>
                        </div>
                    </div>
                    <Table responsive className='text-start mt-3'>
                        <thead className='invite_reffer_thead'>
                            <tr>
                                <th className='border-bottom-0'>Friend ID</th>
                                <th className='border-bottom-0'>Commission Income</th>
                                <th className='border-bottom-0'>Commission Rebate Time</th>
                                <th className='border-bottom-0'>Account Status  </th>
                            </tr>
                        </thead>
                        <tbody>

                        </tbody>
                    </Table>

                    <div>
                        <div className="invite_referral_content d-flex justify-content-between align-items-center">
                           <div className="invite_referral_content_para">
                            <p>Displays all data from the past day. To view detailed transaction history, click "Export".</p>
                           </div>
                           <div className="invite_referral_content_link">
                            <a target='blank'>Export</a>
                           </div>
                        </div>
                    </div>
                  </div>
                </Col>
            </Row>
        </Container>
      </div>
    </>
  )
}
